import { useState, useEffect, useMemo, useRef } from 'react'
import { Loader } from '@googlemaps/js-api-loader'
import { useNavigate } from 'react-router-dom'

const styles = [
  {
    'featureType': 'poi',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'on'
      }
    ]
  },
  {
    'featureType': 'transit',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  }
]

const DEFAULT_MARKER_COLOR = '#92BC62'

const buildSiteIcon = (google, color = DEFAULT_MARKER_COLOR) => {
  const svg = window.btoa(`
      <svg width="88" height="108" viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1586_16849)">
          <path d="M23.647 38.3905C22.7876 39.4647 21.1405 39.4647 20.2811 38.3905C16.6287 33.7355 8.24984 22.6353 8.24984 16.3332C8.24984 8.74202 14.4087 2.58317 21.9998 2.58317C29.591 2.58317 35.7498 8.74202 35.7498 16.3332C35.7498 22.6353 27.3709 33.7355 23.647 38.3905ZM21.9998 11.7498C20.3527 11.7498 18.8488 12.6808 17.9894 14.0415C17.2017 15.4738 17.2017 17.2642 17.9894 18.6248C18.8488 20.0571 20.3527 20.9165 21.9998 20.9165C23.5754 20.9165 25.0793 20.0571 25.9386 18.6248C26.7264 17.2642 26.7264 15.4738 25.9386 14.0415C25.0793 12.6808 23.5754 11.7498 21.9998 11.7498Z" fill="${color}"/>
          <path d="M20.2811 38.3905L19.4943 39.0078L19.5002 39.0152L20.2811 38.3905ZM17.9894 14.0415L17.1439 13.5075L17.1278 13.5331L17.1132 13.5596L17.9894 14.0415ZM17.9894 18.6248L17.124 19.1259L17.1279 19.1326L17.1319 19.1393L17.9894 18.6248ZM25.9386 18.6248L26.7961 19.1393L26.8002 19.1326L26.8041 19.1259L25.9386 18.6248ZM25.9386 14.0415L26.8149 13.5596L26.8003 13.5331L26.7841 13.5075L25.9386 14.0415ZM22.8661 37.7658C22.4071 38.3396 21.521 38.3396 21.062 37.7658L19.5002 39.0152C20.7599 40.5898 23.1681 40.5898 24.4278 39.0152L22.8661 37.7658ZM21.0678 37.7732C19.2475 35.4532 16.2681 31.5503 13.7474 27.4553C12.4869 25.4076 11.3534 23.3313 10.5376 21.3954C9.71514 19.4435 9.24984 17.7126 9.24984 16.3332H7.24984C7.24984 18.1048 7.8319 20.1247 8.69458 22.172C9.56403 24.2354 10.7534 26.4067 12.0442 28.5037C14.6261 32.6981 17.6623 36.6728 19.4944 39.0077L21.0678 37.7732ZM9.24984 16.3332C9.24984 9.29431 14.961 3.58317 21.9998 3.58317V1.58317C13.8564 1.58317 7.24984 8.18974 7.24984 16.3332H9.24984ZM21.9998 3.58317C29.0387 3.58317 34.7498 9.29431 34.7498 16.3332H36.7498C36.7498 8.18974 30.1433 1.58317 21.9998 1.58317V3.58317ZM34.7498 16.3332C34.7498 17.7125 34.2846 19.4433 33.4611 21.395C32.6444 23.3306 31.5088 25.4066 30.2441 27.454C27.7152 31.548 24.7184 35.4504 22.8661 37.7658L24.4278 39.0152C26.2995 36.6756 29.3542 32.7003 31.9457 28.505C33.2412 26.4077 34.4331 24.2361 35.3038 22.1725C36.1677 20.1249 36.7498 18.1048 36.7498 16.3332H34.7498ZM21.9998 10.7498C19.9722 10.7498 18.1656 11.8898 17.1439 13.5075L18.8349 14.5755C19.532 13.4718 20.7332 12.7498 21.9998 12.7498V10.7498ZM17.1132 13.5596C16.1648 15.2839 16.1524 17.4476 17.124 19.1259L18.8548 18.1238C18.2509 17.0807 18.2385 15.6637 18.8656 14.5234L17.1132 13.5596ZM17.1319 19.1393C18.1689 20.8676 19.9954 21.9165 21.9998 21.9165V19.9165C20.71 19.9165 19.5287 19.2466 18.8469 18.1103L17.1319 19.1393ZM21.9998 21.9165C23.9412 21.9165 25.7637 20.8601 26.7961 19.1393L25.0811 18.1103C24.3949 19.2542 23.2095 19.9165 21.9998 19.9165V21.9165ZM26.8041 19.1259C27.7757 17.4476 27.7633 15.2839 26.8149 13.5596L25.0624 14.5234C25.6896 15.6637 25.6771 17.0807 25.0732 18.1238L26.8041 19.1259ZM26.7841 13.5075C25.7673 11.8976 23.9641 10.7498 21.9998 10.7498V12.7498C23.1866 12.7498 24.3912 13.4641 25.0932 14.5755L26.7841 13.5075Z" fill="white"/>
        </g>
        <defs>
          <filter id="filter0_d_1586_16849" x="-6" y="-1" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="6"/>
            <feGaussianBlur stdDeviation="4"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1586_16849"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1586_16849" result="shape"/>
          </filter>
        </defs>
      </svg>
     `)

  return {
    url: `data:image/svg+xml;base64,${svg}`,
    scaledSize: new google.maps.Size(56, 64),
  }
}

const Map = ({ site, positions, height = 300, minWidth = '350px', color = DEFAULT_MARKER_COLOR }) => {
  const [google, setGoogle] = useState(null)
  const [map, setMap] = useState(null)
  const navigate = useNavigate()
  const markersRef = useRef([])

  const markers = useMemo(() => {
    if (!google || !map) {
      return []
    }
    
    markersRef.current.forEach(marker => marker.setMap(null))
    markersRef.current = []
    
    const newMarkers = positions.map(position => {
      const newMarker = new google.maps.Marker({
        position,
        icon: buildSiteIcon(google, color),
      })
      newMarker.setMap(map)
      newMarker.addListener('click', () => {
        navigate({
          pathname: `/monitoring/map/${site.sf_id}`,
        })
      })
      return newMarker
    })
    
    markersRef.current = newMarkers
    return newMarkers
  }, [map, positions, google, color])

  useEffect(() => {
    if (google === null) {
      ; (async () => {
        const loader = new Loader({
          apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
          libraries: ['geometry'],
          version: 'weekly',
        })

        loader
          .load()
          .then((value) => {
            setGoogle(value)
          })
          .catch((e) => console.log(e))
      })()
    }
  }, [google])

  useEffect(() => {
    if (google) {
      const element = document.getElementById('mapViewSite')
      const newMap = new google.maps.Map(element, {
        center: { lat: 48.873259, lng: 2.305976 },
        mapTypeId: 'roadmap',
        disableDefaultUI: true,
        styles,
      })
      setMap(newMap)
    }
    document.getElementById('pin_site')?.addEventListener('hover', function (e) {
      e.currentTarget.setAttribute('stroke', 'red');
      e.currentTarget.setAttribute('stroke-width', '4');
    });
  }, [google])

  useEffect(() => {
    if (google && map) {
      if (markers.length === 1) {
        map.setZoom(15);
        map.setCenter(markers[0].position);
      } else {
        const bounds = new google.maps.LatLngBounds();
        markers.forEach(({ position }) => bounds.extend(position));
        map.fitBounds(bounds);
      }

    }
  }, [google, map, markers])

  if (!google && !map) {
    return <div>Loading ....</div>
  }
  return (
    <div
      style={{
        borderRadius: '10px',
        width: '100%',
        minWidth,
        maxWidth: '100%',
        boxSizing: 'border-box',
        height: `${height}px`,
        border: '1px solid #D7DAEA',
      }}
      id={'mapViewSite'}
    />
  );
}

export default Map
